import authReducer from "./Reducers/authReducer";
import productReducer from "./Reducers/productReducer";
import contactUsReducer from "./Reducers/contactUsReducer";
import propertyReducer from "./Reducers/PropertiesReducer";
import newsArticlesReducer from "./Reducers/newsArticles";
import commentsReducer from "./Reducers/CommentsReducer";
import amenitiesReducer from "./Reducers/amenitiesReducer";
import newsBannerReducer from "./Reducers/newsBannerReducer";
import aqiReducer from "./Reducers/AQIReducer";
import reelsReducer from "./Reducers/reelsReducer";
import blogsReducer from "./Reducers/blogsReducer";
import synckReducer from "./Reducers/synckReducer";
import inquiryReducer from "./Reducers/inquiryReducer";
import loggerReducer from "./Reducers/loggerReducer";
import OutpropertyReducer from "./Reducers/outpropertyReducer";
import metaReducer from "./Reducers/metaReducer";
import galleryReducer from "./Reducers/GalleryReducer";
import mapsReducer from "./Reducers/mapReducer";

const rootReducer = {
  auth: authReducer,
  product: productReducer,
  contactus: contactUsReducer,
  properties: propertyReducer,
  news: newsArticlesReducer,
  synck: synckReducer,
  comments: commentsReducer,
  amenities: amenitiesReducer,
  newsBanners: newsBannerReducer,
  aqi: aqiReducer,
  reels: reelsReducer,
  blogs: blogsReducer,
  inquiry: inquiryReducer,
  ipLogger: loggerReducer,
  Outproperty: OutpropertyReducer,
  gallery: galleryReducer,
  meta: metaReducer,
  maps: mapsReducer,
};
export default rootReducer;
